import styled from 'styled-components';

import { mediaSmallOrTiny, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceXXL,
  spaceXL,
  cornerRadius3XL,
  xdlColorBackground,
  xdlColorHoverTertiary,
  dropShadowS,
} from '@xing-com/tokens';

import {
  CARD_GAP,
  DECK_CONTAINER_HEIGHT,
  CARD_HEIGHT,
  CARD_HIDDEN_HEIGHT,
  CARD_WIDTH,
  CARD_Z_INDEX,
} from './constants';

const DeckCard = styled.div`
  border: 2px solid transparent;
  background-color: ${xdlColorBackground};
  border-radius: ${cornerRadius3XL};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 342px;
  height: 440px;
  padding: ${spaceXL};
  box-shadow: ${dropShadowS};
  cursor: pointer;

  &:hover {
    border: 2px solid ${xdlColorHoverTertiary};
  }
`;

const StackContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${CARD_HEIGHT + 2 * CARD_HIDDEN_HEIGHT}px;
  width: ${CARD_WIDTH}px;
`;

const ActionsContainer = styled.div`
  position: absolute;
  bottom: -8px;
  z-index: ${CARD_Z_INDEX};
  transition: opacity 0.5s ease;

  @media ${mediaSmallOrTiny} {
    opacity: 1;
    pointer-events: auto;
  }
`;

const DecksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spaceL};
  gap: ${CARD_GAP}px;
  margin-bottom: ${spaceXXL};
  min-height: ${DECK_CONTAINER_HEIGHT}px;

  @media ${mediaTopBarVisible} {
    margin-top: 0;
  }
`;

export { DeckCard, StackContainer, ActionsContainer, DecksContainer };
